import {getUpdatedActivityIds} from '@gaia/components/ActivityList';
import type {ActivityData} from '@gaia/types';
import memoize from 'lodash/memoize';

// Accepts an activity id by way of selectedActivities and returns the activity object for the id
// Used if you need a reference to both the updated activity id and old activity ids

const getActivityObject = memoize(
    (selectedActivities: string[], activitiesData: ActivityData[] | undefined) => {
        if (selectedActivities.length < 1 || !activitiesData) return;
        const updatedActivity = getUpdatedActivityIds(selectedActivities, activitiesData);
        return activitiesData.find((activity) => activity.id === updatedActivity[0]);
    },
    (...args) => JSON.stringify(args)
);
export default getActivityObject;
